import * as React from "react";

interface INavDropdownProps {
    name: string;
    id: number;
    isOpen: boolean;
    toggleMenu: (id: number, visible: boolean) => void;
}

interface INavDropDownState {
    isOpen: boolean;
    timeoutID: number;
}

class NavDropdown extends React.Component<INavDropdownProps, INavDropDownState>{

    constructor(props: INavDropdownProps) {
        super(props);

        this.state = {
            isOpen: false,
            timeoutID: -1
        };

        this.mouseOut = this.mouseOut.bind(this);
        this.mouseEnter = this.mouseEnter.bind(this);
        this.showMenu = this.showMenu.bind(this);
        this.hideMenu = this.hideMenu.bind(this);
    }

    public render() {
        return (
            <li className={`nav-item dropdown ${this.props.isOpen ? "show" : ""}`} onMouseLeave={this.mouseOut} onMouseEnter={this.mouseEnter} >
                <a className="nav-link dropdown-toggle" href="#" onClick={this.showMenu}>{this.props.name}</a>
                <div className={`nav-item dropdown-menu dropdown-menu-right ${this.props.isOpen ? "show" : ""}`}
                    onClick={this.hideMenu}>
                    {this.props.isOpen && this.props.children}
                </div>
            </li>
        );
    }

    public componentWillUnmount() {
        this.clearTimeout();
    }

    private showMenu() {
        this.props.toggleMenu(this.props.id, true);
    }

    private hideMenu() {
        this.props.toggleMenu(this.props.id, false);
    }

    private mouseOut() {
        if (this.state.timeoutID < 0) {
            const timeoutID = window.setTimeout(() => {
                this.props.toggleMenu(this.props.id, false);
                this.setState({ timeoutID: -1 });
            }, 1000);

            this.setState({ timeoutID });
        }
    }

    private mouseEnter() {
        this.clearTimeout();
    }

    private clearTimeout() {
        if (this.state.timeoutID >= 0) {
            window.clearTimeout(this.state.timeoutID);
            this.setState({ timeoutID: -1 });
        }
    }
}

export default NavDropdown;



// WEBPACK FOOTER //
// ./src/components/Nav/NavDropdown.tsx